module.exports = __webpack_public_path__ + "static/media/burger.bf56de00.glb";